








































import { Vue, Mixins, Component, Prop, Watch } from 'vue-property-decorator';
import { evalSettingModule } from '@/store/modules/entities/eval-setting.module';
import { EvalSetting } from '@/models/evalSetting/eval-setting';
import { Competency, CompetencySelection } from '@/models/competency/competency';
import { masterModule } from '@/store/modules/entities/master.module';
import GJgrowEventCreateSelection from '@/views/GJgrowEventCreate/QuestionSetting/GJgrowEventCreateQuestionSettingCompetencySelection.vue';
import GJgrowEventCreateFormFormat from '@/views/GJgrowEventCreate/GJgrowEventCreateFormFormat.vue';
import { examCreateModule } from '@/store/modules/frames/exam-create.module';
import { EventParam } from '@/models/jgrow/event-param';
import { jgrowEventCreateModule } from '@/store/modules/frames/jgrow-event-create.module';
import { GPageBase } from '@/mixins';
import GVTag from '@/components/GVTag.vue';
import { GEnum } from '@/constants/enum.defination';

@Component({
  name: 'GJgrowEventCreateQuestionSettingDetail',
  components: { GVTag, GJgrowEventCreateFormFormat, GJgrowEventCreateSelection },
  computed: {},
  methods: {},
})
export default class GJgrowEventCreateQuestionSettingDetail extends Mixins(GPageBase) {
  @Prop() isDisable: boolean;

  mounted() {}

  get isDisabledModeBasic(): boolean {
    return jgrowEventCreateModule.params.competencySettingType === GEnum.JgrowCompetencySettingType.Basic;
  }

  get selectionCognitive(): CompetencySelection {
    return jgrowEventCreateModule.selectionCognitive;
  }
  get selectionSelf(): CompetencySelection {
    return jgrowEventCreateModule.selectionSelf;
  }
  get selectionGift(): CompetencySelection {
    return jgrowEventCreateModule.selectionGift;
  }
  get selectionCommunity(): CompetencySelection {
    return jgrowEventCreateModule.selectionCommunity;
  }

  get competencyCognitiveIncludeIsValid(): Competency[] {
    return masterModule.competencyCognitiveIncludeIsValid;
  }

  get competencySelfIncludeIsValid(): Competency[] {
    return masterModule.competencySelfIncludeIsValid;
  }

  get competencyGiftIncludeIsValid(): Competency[] {
    return masterModule.competencyGiftIncludeIsValid;
  }

  get competencyCommunityIncludeIsValid(): Competency[] {
    return masterModule.competencyCommunityIncludeIsValid;
  }

  get isDisplayTrend(): boolean {
    // 追加サービスプランに傾向チェックが含まれている場合、表示する
    return this.$store.state.account.additionalPlanTypes.includes(GEnum.AdditionalPlanType.TrendCheckAcademic);
  }

  get evalSettingDetail(): EvalSetting {
    return evalSettingModule.evalSettingDetail;
  }

  get evalSettingModeEditAndUnderExamination(): boolean {
    return examCreateModule.evalSettingModeEdit && this.evalSettingDetail.isUnderExamination;
  }

  get isNonCompetencySelected(): boolean {
    return (
      (this.evalSettingDetail.giftRequired || this.evalSettingDetail.selfEvalRequired) &&
      this.selectionCognitive.checkAllGroup.length === 0 &&
      this.selectionSelf.checkAllGroup.length === 0 &&
      this.selectionGift.checkAllGroup.length === 0 &&
      this.selectionCommunity.checkAllGroup.length === 0
    );
  }

  get isEvalItemAllUnchecked(): boolean {
    return !this.evalSettingDetail.iatRequired && !this.evalSettingDetail.selfEvalRequired && !this.evalSettingDetail.giftRequired && !this.evalSettingDetail.trendRequired;
  }

  isValid(): boolean {
    return !this.isNonCompetencySelected && !this.isEvalItemAllUnchecked;
  }

  handleExam() {
    if (!this.evalSettingDetail.selfEvalRequired && !this.evalSettingDetail.giftRequired) {
      examCreateModule.cleanCompetencySelections();
    }
  }
}
